import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.073 2.002A2.82 2.82 0 0 1 4 1.25h8a2.82 2.82 0 0 1 1.927.752c.52.488.823 1.16.823 1.873V5H16a2.82 2.82 0 0 1 1.927.752c.52.488.823 1.16.823 1.873v7.5c0 .712-.302 1.385-.823 1.873A2.82 2.82 0 0 1 16 17.75H8a2.82 2.82 0 0 1-1.927-.752 2.57 2.57 0 0 1-.823-1.873V14H4a2.82 2.82 0 0 1-1.927-.752 2.57 2.57 0 0 1-.823-1.873v-7.5c0-.712.302-1.385.823-1.873M6.75 15.125c0 .282.12.563.349.779.231.216.554.346.901.346h8c.347 0 .67-.13.901-.346s.349-.497.349-.779v-7.5c0-.282-.12-.563-.349-.779A1.32 1.32 0 0 0 16 6.5H8c-.347 0-.67.13-.901.346s-.349.497-.349.779zM13.25 5H8a2.82 2.82 0 0 0-1.927.752 2.57 2.57 0 0 0-.823 1.873V12.5H4c-.347 0-.67-.13-.901-.346a1.07 1.07 0 0 1-.349-.779v-7.5c0-.282.12-.563.349-.779A1.32 1.32 0 0 1 4 2.75h8c.347 0 .67.13.901.346s.349.497.349.779z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }